import { BaseWebComponent } from "./webcomponent-base";

export class SidebarSectionWebComponent extends BaseWebComponent {
    static webComponentName = "wc-sidebar-section";
    static observedAttributes = [];
    get title(): string {
        return this.getAttribute('title') || "";
    }
    constructor() {
        super();
    }
    private rendered: boolean = false;
    render(): void {
        if(this.title && !this.rendered) { 
            this.rendered = true;
            // inserisco come primo elemento un titolo di sezione costruendo un h6
            const titleElement = document.createElement('h6');
            titleElement.classList.add('sidebar-nav-section-title');
            titleElement.textContent = this.title;
            this.prepend(titleElement);
        }
        return ; // non c'è niente da renderizzare
    }
}

